"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _Page = _interopRequireDefault(require("../model/Page"));
var _PageAccessControl = _interopRequireDefault(require("../model/PageAccessControl"));
var _PageProductPairing = _interopRequireDefault(require("../model/PageProductPairing"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* ContentCms service.
* @module api/ContentCmsApi
* @version 3.0
*/
var ContentCmsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new ContentCmsApi. 
  * @alias module:api/ContentCmsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ContentCmsApi(apiClient) {
    _classCallCheck(this, ContentCmsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Get a specific Campaign Page
   * Get a specific Page within the CMS which is categorised as a ‘campaign’ Page.
   * @param {Number} contentsysId Content System Id
   * @param {Number} pageId Page Id
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Page} and HTTP response
   */
  return _createClass(ContentCmsApi, [{
    key: "getCampaignPageWithHttpInfo",
    value: function getCampaignPageWithHttpInfo(contentsysId, pageId) {
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getCampaignPage");
      }
      // verify the required parameter 'pageId' is set
      if (pageId === undefined || pageId === null) {
        throw new Error("Missing the required parameter 'pageId' when calling getCampaignPage");
      }
      var pathParams = {
        'contentsysId': contentsysId,
        'pageId': pageId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Page["default"];
      return this.apiClient.callApi('/content/{contentsysId}/pages-campaigns/{pageId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Campaign Page
     * Get a specific Page within the CMS which is categorised as a ‘campaign’ Page.
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Page}
     */
  }, {
    key: "getCampaignPage",
    value: function getCampaignPage(contentsysId, pageId) {
      return this.getCampaignPageWithHttpInfo(contentsysId, pageId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Campaign Pages
     * Get a list of Pages categorized as 'campaign' within a CMS.<br>If a UserId is passed in, only campaign pages available to that User will be returned.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the campaign pages returned to that specific Operator.<br>Passing in a status, or comma separated list of statuses will return only campaign pages which are in those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only campaign pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned. <br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {Number} [userId = 1)] User Id
     * @param {String} [lang = 'en-gb')] Language
     * @param {String} [operator = '')] Operator
     * @param {String} [status = '')] Status
     * @param {String} [tags] Tags
     * @param {String} [accessControlled = 'false')] Access Controlled
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Page>} and HTTP response
     */
  }, {
    key: "getCampaignPagesWithHttpInfo",
    value: function getCampaignPagesWithHttpInfo(contentsysId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getCampaignPages");
      }
      var pathParams = {
        'contentsysId': contentsysId
      };
      var queryParams = {
        'userId': opts['userId'],
        'lang': opts['lang'],
        'operator': opts['operator'],
        'status': opts['status'],
        'tags': opts['tags'],
        'accessControlled': opts['accessControlled']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Page["default"]];
      return this.apiClient.callApi('/content/{contentsysId}/pages-campaigns', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Campaign Pages
     * Get a list of Pages categorized as 'campaign' within a CMS.<br>If a UserId is passed in, only campaign pages available to that User will be returned.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the campaign pages returned to that specific Operator.<br>Passing in a status, or comma separated list of statuses will return only campaign pages which are in those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only campaign pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned. <br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.userId User Id (default to 1)
     * @param {String} opts.lang Language (default to 'en-gb')
     * @param {String} opts.operator Operator (default to '')
     * @param {String} opts.status Status (default to '')
     * @param {String} opts.tags Tags
     * @param {String} opts.accessControlled Access Controlled (default to 'false')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Page>}
     */
  }, {
    key: "getCampaignPages",
    value: function getCampaignPages(contentsysId, opts) {
      return this.getCampaignPagesWithHttpInfo(contentsysId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Customer Notification Pages
     * Get a list of Pages categorized as ‘customer notifications’ within a CMS.<br>If a UserId is passed in, only customer notification pages available to that User will be returned.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the customer notification pages returned to that specific Operator.<br>Passing in a status, or comma separated list of statuses will return only customer notification pages which are assigned those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only customer notification pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned.<br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {Number} [userId = 1)] User Id
     * @param {String} [lang = 'en-gb')] Language
     * @param {String} [operator = '')] Operator
     * @param {String} [status = '')] Status
     * @param {String} [tags] Tags
     * @param {String} [accessControlled = 'false')] Access Controlled
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Page>} and HTTP response
     */
  }, {
    key: "getCustomerNotificationPagesWithHttpInfo",
    value: function getCustomerNotificationPagesWithHttpInfo(contentsysId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getCustomerNotificationPages");
      }
      var pathParams = {
        'contentsysId': contentsysId
      };
      var queryParams = {
        'userId': opts['userId'],
        'lang': opts['lang'],
        'operator': opts['operator'],
        'status': opts['status'],
        'tags': opts['tags'],
        'accessControlled': opts['accessControlled']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Page["default"]];
      return this.apiClient.callApi('/content/{contentsysId}/pages-customernotifications', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Customer Notification Pages
     * Get a list of Pages categorized as ‘customer notifications’ within a CMS.<br>If a UserId is passed in, only customer notification pages available to that User will be returned.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the customer notification pages returned to that specific Operator.<br>Passing in a status, or comma separated list of statuses will return only customer notification pages which are assigned those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only customer notification pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned.<br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.userId User Id (default to 1)
     * @param {String} opts.lang Language (default to 'en-gb')
     * @param {String} opts.operator Operator (default to '')
     * @param {String} opts.status Status (default to '')
     * @param {String} opts.tags Tags
     * @param {String} opts.accessControlled Access Controlled (default to 'false')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Page>}
     */
  }, {
    key: "getCustomerNotificationPages",
    value: function getCustomerNotificationPages(contentsysId, opts) {
      return this.getCustomerNotificationPagesWithHttpInfo(contentsysId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Intercept Page
     * Get a specific Page with the category of ‘Intercept’ within a CMSof type 'intercept'.
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Page} and HTTP response
     */
  }, {
    key: "getInterceptPageWithHttpInfo",
    value: function getInterceptPageWithHttpInfo(contentsysId, pageId) {
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getInterceptPage");
      }
      // verify the required parameter 'pageId' is set
      if (pageId === undefined || pageId === null) {
        throw new Error("Missing the required parameter 'pageId' when calling getInterceptPage");
      }
      var pathParams = {
        'contentsysId': contentsysId,
        'pageId': pageId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Page["default"];
      return this.apiClient.callApi('/content/{contentsysId}/pages-intercepts/{pageId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Intercept Page
     * Get a specific Page with the category of ‘Intercept’ within a CMSof type 'intercept'.
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Page}
     */
  }, {
    key: "getInterceptPage",
    value: function getInterceptPage(contentsysId, pageId) {
      return this.getInterceptPageWithHttpInfo(contentsysId, pageId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Intercept Pages
     * Get a list of Pages categorized as 'intercept' within a CMS.<br>If a UserId is passed in, only intercept pages available to that User will be returned.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the intercept pages returned to that specific Operator.<br>Passing in a status, or comma separated list of statuses will return only intercept pages which are in those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only intercept pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned. <br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {Number} [userId = 1)] User Id
     * @param {String} [lang = 'en-gb')] Language
     * @param {String} [operator = '')] Operator
     * @param {String} [status = '')] Status
     * @param {String} [tags] Tags
     * @param {String} [accessControlled = 'false')] Access Controlled
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Page>} and HTTP response
     */
  }, {
    key: "getInterceptPagesWithHttpInfo",
    value: function getInterceptPagesWithHttpInfo(contentsysId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getInterceptPages");
      }
      var pathParams = {
        'contentsysId': contentsysId
      };
      var queryParams = {
        'userId': opts['userId'],
        'lang': opts['lang'],
        'operator': opts['operator'],
        'status': opts['status'],
        'tags': opts['tags'],
        'accessControlled': opts['accessControlled']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Page["default"]];
      return this.apiClient.callApi('/content/{contentsysId}/pages-intercepts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Intercept Pages
     * Get a list of Pages categorized as 'intercept' within a CMS.<br>If a UserId is passed in, only intercept pages available to that User will be returned.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the intercept pages returned to that specific Operator.<br>Passing in a status, or comma separated list of statuses will return only intercept pages which are in those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only intercept pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned. <br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.userId User Id (default to 1)
     * @param {String} opts.lang Language (default to 'en-gb')
     * @param {String} opts.operator Operator (default to '')
     * @param {String} opts.status Status (default to '')
     * @param {String} opts.tags Tags
     * @param {String} opts.accessControlled Access Controlled (default to 'false')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Page>}
     */
  }, {
    key: "getInterceptPages",
    value: function getInterceptPages(contentsysId, opts) {
      return this.getInterceptPagesWithHttpInfo(contentsysId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Page.
     * Get a specific page within the CMS (Or SSB when there is a lack of a CMS).<br>The category filter will limit the results to only those which match the given category.<br>
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @param {Object} opts Optional parameters
     * @param {String} [category = 'CAMPAIGN')] Category
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Page} and HTTP response
     */
  }, {
    key: "getPageWithHttpInfo",
    value: function getPageWithHttpInfo(contentsysId, pageId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getPage");
      }
      // verify the required parameter 'pageId' is set
      if (pageId === undefined || pageId === null) {
        throw new Error("Missing the required parameter 'pageId' when calling getPage");
      }
      var pathParams = {
        'contentsysId': contentsysId,
        'pageId': pageId
      };
      var queryParams = {
        'category': opts['category']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Page["default"];
      return this.apiClient.callApi('/content/{contentsysId}/pages/{pageId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Page.
     * Get a specific page within the CMS (Or SSB when there is a lack of a CMS).<br>The category filter will limit the results to only those which match the given category.<br>
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @param {Object} opts Optional parameters
     * @param {String} opts.category Category (default to 'CAMPAIGN')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Page}
     */
  }, {
    key: "getPage",
    value: function getPage(contentsysId, pageId, opts) {
      return this.getPageWithHttpInfo(contentsysId, pageId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Page Access Controls for a Page
     * Gets a List of Page Access Control for a Page.<br>Passing in a UserId will get the Page Access Controls for that Page, for that specific User.<br>Page Access Controls are used to record the interactions between a User and a Page, handling if the Page is ‘New’ to the User, or if the User has ‘seen’ the Page for example.<br>
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @param {Object} opts Optional parameters
     * @param {Number} [userId = 1)] User Id
     * @param {String} [status = '')] Status
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/PageAccessControl>} and HTTP response
     */
  }, {
    key: "getPageAccessControlsWithHttpInfo",
    value: function getPageAccessControlsWithHttpInfo(contentsysId, pageId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getPageAccessControls");
      }
      // verify the required parameter 'pageId' is set
      if (pageId === undefined || pageId === null) {
        throw new Error("Missing the required parameter 'pageId' when calling getPageAccessControls");
      }
      var pathParams = {
        'contentsysId': contentsysId,
        'pageId': pageId
      };
      var queryParams = {
        'userId': opts['userId'],
        'status': opts['status']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_PageAccessControl["default"]];
      return this.apiClient.callApi('/content/{contentsysId}/pages/{pageId}/pageaccesscontrol', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Page Access Controls for a Page
     * Gets a List of Page Access Control for a Page.<br>Passing in a UserId will get the Page Access Controls for that Page, for that specific User.<br>Page Access Controls are used to record the interactions between a User and a Page, handling if the Page is ‘New’ to the User, or if the User has ‘seen’ the Page for example.<br>
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.userId User Id (default to 1)
     * @param {String} opts.status Status (default to '')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/PageAccessControl>}
     */
  }, {
    key: "getPageAccessControls",
    value: function getPageAccessControls(contentsysId, pageId, opts) {
      return this.getPageAccessControlsWithHttpInfo(contentsysId, pageId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists page-product pairings linked to a Page.
     * Get a list of page-product pairings that have been linked to a Page.<br>These are Products from the Catalog which have a link to the Page – for example this Product is being promoted by the Page.
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/PageProductPairing>} and HTTP response
     */
  }, {
    key: "getPageProductPairingsWithHttpInfo",
    value: function getPageProductPairingsWithHttpInfo(contentsysId, pageId) {
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getPageProductPairings");
      }
      // verify the required parameter 'pageId' is set
      if (pageId === undefined || pageId === null) {
        throw new Error("Missing the required parameter 'pageId' when calling getPageProductPairings");
      }
      var pathParams = {
        'contentsysId': contentsysId,
        'pageId': pageId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_PageProductPairing["default"]];
      return this.apiClient.callApi('/content/{contentsysId}/pages/{pageId}/pageproductpairings', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists page-product pairings linked to a Page.
     * Get a list of page-product pairings that have been linked to a Page.<br>These are Products from the Catalog which have a link to the Page – for example this Product is being promoted by the Page.
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/PageProductPairing>}
     */
  }, {
    key: "getPageProductPairings",
    value: function getPageProductPairings(contentsysId, pageId) {
      return this.getPageProductPairingsWithHttpInfo(contentsysId, pageId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List content Pages.
     * Get a list of pages within a CMS (Or SSB if there is a lack of a CMS)<br>Passing in a category will limit the Pages returned to the specific category or categories provided.<br>If a user Id is provided then the returned list will only contain those Pages that are relevant to the User.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the Pages returned to those owned by the Operator input.<br>Adding in a status, or comma separated list of statuses will return only Pages which are in those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only Pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned<br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {String} [category = 'CAMPAIGN')] Category
     * @param {Number} [userId = -1)] User Id
     * @param {String} [lang = 'en-gb')] Language
     * @param {String} [operator = '')] Operator
     * @param {String} [status = '')] Status
     * @param {String} [tags] Tags
     * @param {String} [accessControlled = 'false')] Access Controlled
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Page>} and HTTP response
     */
  }, {
    key: "getPagesWithHttpInfo",
    value: function getPagesWithHttpInfo(contentsysId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling getPages");
      }
      var pathParams = {
        'contentsysId': contentsysId
      };
      var queryParams = {
        'category': opts['category'],
        'userId': opts['userId'],
        'lang': opts['lang'],
        'operator': opts['operator'],
        'status': opts['status'],
        'tags': opts['tags'],
        'accessControlled': opts['accessControlled']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Page["default"]];
      return this.apiClient.callApi('/content/{contentsysId}/pages', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List content Pages.
     * Get a list of pages within a CMS (Or SSB if there is a lack of a CMS)<br>Passing in a category will limit the Pages returned to the specific category or categories provided.<br>If a user Id is provided then the returned list will only contain those Pages that are relevant to the User.<br>Using the language filter will limit the results to those which match the inputted language.<br>Passing in an Operator will limit the Pages returned to those owned by the Operator input.<br>Adding in a status, or comma separated list of statuses will return only Pages which are in those statuses.<br>Tags can be passed in as a comma separated list. Passing in tags will filter the results to those which match ALL the tags passed in.<br>If the access controlled flag is passed in as ‘true’, only Pages which are ‘access controlled’ i.e. can only be viewed a limited number of times, are returned<br>
     * @param {Number} contentsysId Content System Id
     * @param {Object} opts Optional parameters
     * @param {String} opts.category Category (default to 'CAMPAIGN')
     * @param {Number} opts.userId User Id (default to -1)
     * @param {String} opts.lang Language (default to 'en-gb')
     * @param {String} opts.operator Operator (default to '')
     * @param {String} opts.status Status (default to '')
     * @param {String} opts.tags Tags
     * @param {String} opts.accessControlled Access Controlled (default to 'false')
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Page>}
     */
  }, {
    key: "getPages",
    value: function getPages(contentsysId, opts) {
      return this.getPagesWithHttpInfo(contentsysId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify Page Access Control
     * Modify (fill-in) a Page Access Control to update any Actions or Status changes necessary for that particular User.
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @param {Number} pageaccesscontrolId Page Access Control Id
     * @param {module:model/PageAccessControl} pageAccessControl Page Access Control info that will be used to update
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PageAccessControl} and HTTP response
     */
  }, {
    key: "modifyPageAccessControlsWithHttpInfo",
    value: function modifyPageAccessControlsWithHttpInfo(contentsysId, pageId, pageaccesscontrolId, pageAccessControl) {
      var postBody = pageAccessControl;
      // verify the required parameter 'contentsysId' is set
      if (contentsysId === undefined || contentsysId === null) {
        throw new Error("Missing the required parameter 'contentsysId' when calling modifyPageAccessControls");
      }
      // verify the required parameter 'pageId' is set
      if (pageId === undefined || pageId === null) {
        throw new Error("Missing the required parameter 'pageId' when calling modifyPageAccessControls");
      }
      // verify the required parameter 'pageaccesscontrolId' is set
      if (pageaccesscontrolId === undefined || pageaccesscontrolId === null) {
        throw new Error("Missing the required parameter 'pageaccesscontrolId' when calling modifyPageAccessControls");
      }
      // verify the required parameter 'pageAccessControl' is set
      if (pageAccessControl === undefined || pageAccessControl === null) {
        throw new Error("Missing the required parameter 'pageAccessControl' when calling modifyPageAccessControls");
      }
      var pathParams = {
        'contentsysId': contentsysId,
        'pageId': pageId,
        'pageaccesscontrolId': pageaccesscontrolId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _PageAccessControl["default"];
      return this.apiClient.callApi('/content/{contentsysId}/pages/{pageId}/pageaccesscontrol/{pageaccesscontrolId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify Page Access Control
     * Modify (fill-in) a Page Access Control to update any Actions or Status changes necessary for that particular User.
     * @param {Number} contentsysId Content System Id
     * @param {Number} pageId Page Id
     * @param {Number} pageaccesscontrolId Page Access Control Id
     * @param {module:model/PageAccessControl} pageAccessControl Page Access Control info that will be used to update
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PageAccessControl}
     */
  }, {
    key: "modifyPageAccessControls",
    value: function modifyPageAccessControls(contentsysId, pageId, pageaccesscontrolId, pageAccessControl) {
      return this.modifyPageAccessControlsWithHttpInfo(contentsysId, pageId, pageaccesscontrolId, pageAccessControl).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();